import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const init = () => {
  Fancybox.bind('[data-fancybox="video"]', {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "slideShow", "thumbs", "close"],
    },
  });

  Fancybox.bind('[data-fancybox="gallery-item"]', {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "slideShow", "thumbs", "close"],
    },
  });
  Fancybox.bind('[data-fancybox="gallery-item-2"]', {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "slideShow", "thumbs", "close"],
    },
  });
};

init();
